// extracted by mini-css-extract-plugin
module.exports = {"ownersArray":"styles_ownersArray__xK6B9","sponsoredFee":"styles_sponsoredFee__D4VHp"};